import { Heart, Menu, Search, ShoppingBag, UserRound, X } from 'lucide-react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useCommerce } from '../contexts/CommerceContext';

type HeaderProps = { onSearch: () => void };
type NavigationItem = { label: string; to: string; isRoute?: boolean };

const navigation: NavigationItem[] = [
  { label: 'Início', to: '/' },
  { label: 'Fitness', to: '/fitness' },
  { label: 'Moda Praia', to: '/moda-praia' },
  { label: 'Lingerie', to: '/lingerie' },
  { label: 'Novidades', to: '/novidades' },
  { label: 'Sobre nós', to: '/#sobre', isRoute: false },
];

export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand" aria-label="Sena Beachway">
      <span className="brand-monogram" aria-hidden="true">SB</span>
      {!compact && <span className="brand-name">SENA BEACHWAY</span>}
    </span>
  );
}

export function Header({ onSearch }: HeaderProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { cartCount, setCartOpen, user } = useCommerce();
  const navigate = useNavigate();
  const accountHref = user ? '/minha-conta' : '/entrar';

  const navigateFromMobile = (to: string) => {
    setMobileOpen(false);
    navigate(to);
  };

  return (
    <header className="site-header">
      <div className="header-inner">
        <button className="icon-button mobile-only" aria-label="Abrir menu" onClick={() => setMobileOpen(true)}>
          <Menu size={20} />
        </button>
        <Link className="brand-link" to="/" aria-label="Sena Beachway - início"><BrandMark /></Link>
        <nav className="desktop-nav" aria-label="Navegação principal">
          {navigation.map((item) => (
            item.isRoute === false ? (
              <Link key={item.label} to={item.to}>{item.label}</Link>
            ) : (
              <NavLink key={item.label} end to={item.to} className={({ isActive }) => isActive ? 'is-active' : undefined}>
                {item.label}
              </NavLink>
            )
          ))}
        </nav>
        <div className="header-actions">
          <button className="icon-button" aria-label="Buscar produtos" onClick={onSearch}><Search size={19} /></button>
          <Link className="icon-button desktop-action" aria-label={user ? 'Minha conta' : 'Entrar'} to={accountHref}><UserRound size={19} /></Link>
          <Link className="icon-button desktop-action" aria-label="Favoritos" to="/favoritos"><Heart size={19} /></Link>
          <button className="icon-button cart-button" aria-label={`Carrinho com ${cartCount} item(ns)`} onClick={() => setCartOpen(true)}>
            <ShoppingBag size={19} />
            {cartCount > 0 && <span className="count-badge">{cartCount}</span>}
          </button>
        </div>
      </div>

      <aside className={`mobile-menu ${mobileOpen ? 'is-open' : ''}`} aria-hidden={!mobileOpen}>
        <div className="mobile-menu-head">
          <BrandMark />
          <button className="icon-button" aria-label="Fechar menu" onClick={() => setMobileOpen(false)}><X /></button>
        </div>
        <nav aria-label="Menu mobile">
          {navigation.map((item) => (
            <button key={item.label} onClick={() => navigateFromMobile(item.to)}>{item.label}</button>
          ))}
        </nav>
        <div className="mobile-menu-links">
          <button onClick={() => { setMobileOpen(false); onSearch(); }}>Buscar</button>
          <button onClick={() => navigateFromMobile(accountHref)}>{user ? 'Minha conta' : 'Entrar'}</button>
          <button onClick={() => navigateFromMobile('/favoritos')}>Favoritos</button>
        </div>
      </aside>
      {mobileOpen && <button className="page-scrim" aria-label="Fechar menu" onClick={() => setMobileOpen(false)} />}
    </header>
  );
}
